import {createSelector} from "reselect";

const Users = (state) => state.users;

export const getUserListDetails = createSelector(
  Users,
  (Users) => Users.usersListDetails || {}
);

export const getUsersList = createSelector(
  getUserListDetails,
  (users) => users?.results || []
);

export const getUserTotalCount = createSelector(
  getUserListDetails,
  (users) => users?.total_count
);

export const getUserPaginationUrls = createSelector(getUserListDetails, (users) => ({
  prevUrl: users?.previous,
  nextUrl: users?.next,
}));

export const getUserModalStatus = createSelector(Users, (users) => users.userModalStatus);

export const getUserProfile = createSelector(Users, (users) => users.profile || {});

export const getCustomerUserProfile = createSelector(
  Users,
  (Users) => Users.customerUserProfile
);

export const getOrgUsers = createSelector(Users, (Users) => Users.orgUsers || []);

export const getUsersResources = createSelector(Users, (Users) => Users.resources);
